export default "__VITE_ASSET__PXW7u166__"